import React from 'react';
import {ViewPort, Container} from './TileContainer.styled';

export const TileContainer: React.FC = ({children}) => {
  return (
    <ViewPort>
      <Container>
        {children}
      </Container>
    </ViewPort>
  );
};
